document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('ContactForm');
  if (!form) return;

  const type = form.querySelector('#ContactForm-type');
  const groups = [...form.querySelectorAll('[data-contact-fields]')];
  const company = form.querySelector('#ContactForm-company');
  const params = new URLSearchParams(window.location.search);
  const typeMap = {
    product: '商品について',
    fitment: '車種別適合について',
    business: '法人取引について',
    oem: 'OEMについて',
  };

  const updateGroups = () => {
    const value = type.value;
    groups.forEach((group) => {
      const kind = group.dataset.contactFields;
      const visible = kind === 'product'
        ? value === '商品について' || value === '車種別適合について'
        : kind === 'fitment'
          ? value === '車種別適合について'
          : kind === 'business'
            ? value === '法人取引について' || value === 'OEMについて'
            : false;
      group.hidden = !visible;
    });
    const companyRequired = value === '法人取引について' || value === 'OEMについて';
    if (company) {
      company.required = companyRequired;
      company.setAttribute('aria-required', companyRequired ? 'true' : 'false');
    }
  };

  const values = {
    'ContactForm-product': params.get('product') || params.get('商品'),
    'ContactForm-variant': params.get('variant') || params.get('バリエーション'),
    'ContactForm-maker': params.get('maker') || params.get('メーカー'),
    'ContactForm-car': params.get('car') || params.get('車種'),
    'ContactForm-model': params.get('model') || params.get('型式'),
    'ContactForm-year': params.get('year') || params.get('年式'),
  };

  Object.entries(values).forEach(([id, value]) => {
    const input = document.getElementById(id);
    if (input && value) input.value = value;
  });

  const requestedType = typeMap[params.get('type')] || params.get('type');
  if (requestedType && [...type.options].some((option) => option.value === requestedType)) type.value = requestedType;
  else if (values['ContactForm-product']) type.value = '商品について';

  type.addEventListener('change', updateGroups);
  updateGroups();
});
